import '../css/header.css';
import { Button } from 'react-bootstrap';
import { FaCircleArrowRight } from "react-icons/fa6";

function InfoButton() {
  return (
    <Button className='MoreInfoButton' onClick={() => window.alert('Thank you for considering my application!')}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        Unlock 30% off&nbsp;&nbsp;
        <FaCircleArrowRight />
      </div>    
    </Button>
  );
}

export default InfoButton;

// TODO: Make this way more attractive